"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThomsonReutersCallbackPayloadStateSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const types_utils_1 = require("../../types.utils");
const base_callback_state_interface_1 = require("./base-callback-state.interface");
exports.ThomsonReutersCallbackPayloadStateSchema = zod_1.default.object({
    ...base_callback_state_interface_1.BaseCallbackPayloadState,
    action: types_utils_1.stringSchema,
    binderId: types_utils_1.stringSchema,
    taxYear: types_utils_1.yearSchema,
    userId: types_utils_1.stringSchema,
});
